import React from 'react';
import { useSelector } from 'react-redux';
import { Container, SimplePageHeader } from '../components';
import { DefaultLayout } from '../layouts';

const examples = {
  youtube: {
    name: "YouTube",
    url: "https://www.youtube.com/watch?v=oUFJJNQGwhk"
  },
  youtube_playlist: {
    name: "YouTube Playlist",
    url: "https://www.youtube.com/playlist?list=PLogRWNZ498ETeQNYrOlqikEML3bKJcdcx"
  },
  soundcloud: {
    name: "SoundCloud",
    url: "https://soundcloud.com/miami-nights-1984/accelerated"
  },
  facebook: {
    name: "Facebook",
    url: "https://www.facebook.com/facebook/videos/10153231379946729/"
  },
  vimeo: {
    name: "Vimeo",
    url: "https://vimeo.com/90509568"
  },
  twitch: {
    name: "Twitch",
    url: "https://www.twitch.tv/videos/106400740"
  },
  streamable: {
    name: "Streamable",
    url: "https://streamable.com/moo"
  },
  wistia: {
    name: "Wistia",
    url: "https://home.wistia.com/medias/e4a27b971d"
  },
  dailymotion: {
    name: "DailyMotion",
    url: "https://www.dailymotion.com/video/x5e9eog"
  },
  mixcloud: {
    name: "Mixcloud",
    url: "https://www.mixcloud.com/mixcloud/meet-the-curators/"
  },
  vidyard: {
    name: "Vidyard",
    url: "https://video.vidyard.com/watch/YBvcF2BEfvKdowmfrRwk57"
  }
}

const EmbedLinkExample = () => {
  const title = {
    en: 'Embed Link Examples',
    id: 'Contoh Embed Link'
  }
  const language = useSelector(state => state.system.language)

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding/>
      <Container className="py-20">
        <h2 className="text-2xl font-bold mb-4">{title[language.name]}:</h2>
        <table>
          <tbody className="blog-content">
            {
              Object.keys(examples).map(key => (
                <tr className="border-b" key={key}>
                  <td>{examples[key].name}</td>
                  <td className="px-4">:</td>
                  <td>{examples[key].url}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </Container>
    </DefaultLayout>
  )
}

export { EmbedLinkExample }
